export default __webpack_public_path__ + "static/media/iconPlaceholder.b137744a.png";